import { Component, h, Host, State } from '@stencil/core';

@Component({
  tag: 'demo-signet-select',
  shadow: false,
})
export class DemoSignetSelectAlt {
  @State() disabled: boolean;
  @State() searchable: boolean;
  @State() clearable: boolean;
  @State() multi: boolean;
  @State() options = [
    {
      label: 'React Js',
      value: 'reactjs',
    },
    {
      label: 'Vue Js',
      value: 'vuejs',
    },
    {
      label: 'Angular Js',
      value: 'angularjs',
    },
    {
      value: 'flutter',
      label: 'Flutter',
    },
    {
      value: 'html',
      label: 'HTML',
    },
    {
      value: 'css',
      label: 'CSS',
    },
    {
      value: 'tailwindcss',
      label: 'Tailwind CSS',
    },
    {
      value: 'stenciljs',
      label: 'Stencil JS',
    },
  ];

  searchableChange(e) {
    this.searchable = e.target.checked;
  }

  clearableChange(e) {
    this.clearable = e.target.checked;
  }

  multiChange(e) {
    this.multi = e.target.checked;
  }

  disabledChange(e) {
    this.disabled = e.target.checked;
  }

  render() {
    return (
      <Host>
        <signet-select-alt
          label="Technical Skills"
          placeholder="Select skills..."
          isSearchable={this.searchable}
          isClearable={this.clearable}
          isMulti={this.multi}
          disabled={this.disabled}
          options={this.options}
        />

        <div
          style={{
            marginTop: '20px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <signet-checkbox
            label="Searchable"
            checked={this.searchable}
            onChange={(e) => this.searchableChange(e)}
          />

          <div
            style={{
              marginLeft: '20px',
            }}
          ></div>

          <signet-checkbox
            label="Clearable"
            checked={this.clearable}
            onChange={(e) => this.clearableChange(e)}
          />

          <div
            style={{
              marginLeft: '20px',
            }}
          ></div>

          <signet-checkbox
            label="Disabled"
            checked={this.disabled}
            onChange={(e) => this.disabledChange(e)}
          />

          <div
            style={{
              marginLeft: '20px',
            }}
          ></div>

          <signet-checkbox
            label="Multi select"
            checked={this.multi}
            onChange={(e) => this.multiChange(e)}
          />
        </div>
      </Host>
    );
  }
}
